'use client';

var s = {"labelWrapper":"TextEditor-module_labelWrapper__1n_jm"};

export { s as default };
//# sourceMappingURL=TextEditor.module.scss.js.map
